import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";

const ConfirmEmail: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"pending" | "success" | "error">("pending");
  const [errorDetail, setErrorDetail] = useState("");
  const hasConfirmed = useRef(false); // Prevent double fetch

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setErrorDetail("Missing confirmation token.");
      return;
    }

    const confirmEmail = async () => {
      if (hasConfirmed.current) return;
      hasConfirmed.current = true;

      try {
        const res = await fetch(`${API_BASE_URL}/auth/confirm-email?token=${encodeURIComponent(token)}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          const text = await res.text();
          const message = text.startsWith("{") ? JSON.parse(text).error : `Error (${res.status})`;
          throw new Error(message);
        }

        setStatus("success");
        setTimeout(() => navigate("/login"), 3000);
      } catch (err: any) {
        setStatus("error");
        setErrorDetail(err?.message || "Unknown error");
      }
    };

    confirmEmail();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4">
      {status === "pending" && (
        <p className="text-gray-700 text-lg font-medium">🔄 Verifying your email...</p>
      )}

      {status === "success" && (
        <p className="text-green-600 text-xl font-semibold">
          ✅ Email verified successfully! Redirecting to login...
        </p>
      )}

      {status === "error" && (
        <div className="text-red-600 text-center max-w-md">
          ❌ {errorDetail}
          <div className="mt-4">
            <button
              onClick={() => navigate("/register")}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Try registering again
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmEmail;
